import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { AuthProvider } from './features/auth/AuthContext';
import { ThemeProvider } from './features/theme/ThemeContext';
import { ToastProvider } from './features/toast/ToastContext';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Tracking from './pages/Tracking';
import PackageTracking from './pages/PackageTracking';
import AdminPackageScan from './pages/AdminPackageScan';
import Pricing from './pages/Pricing';
import Services from './pages/Services';
import CbmCalculatorPage from './pages/CbmCalculatorPage';
import About from './pages/About';
import Contact from './pages/Contact';
import News from './pages/News';
import SriLankaBaggageCustoms from './pages/SriLankaBaggageCustoms';
import Admin from './pages/Admin';
import AdminLogin from './pages/AdminLogin';
import Register from './pages/Register';
import Login from './pages/Login';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import LoggedOut from './pages/LoggedOut';
import Profile from './pages/Profile';
import ReviewSubmit from './pages/ReviewSubmit';
import LegalPage from './pages/LegalPage';
import GoogleAuthCallback from './pages/GoogleAuthCallback';
import ScrollToTop from './components/ScrollToTop';
import './App.css';
import './styles/jet-public.css';

function AppContent() {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith('/admin');
  const hidePublicChrome =
    !isAdminRoute &&
    ['/login', '/register', '/forgot-password', '/reset-password', '/logged-out', '/auth/google/callback'].includes(location.pathname);

  const appClass = isAdminRoute
    ? 'App App--admin'
    : hidePublicChrome
      ? 'App jet-public App--auth-fullpage'
      : 'App jet-public';

  useEffect(() => {
    if (!hidePublicChrome) return undefined;
    const cls = 'jet-auth-route';
    document.documentElement.classList.add(cls);
    document.body.classList.add(cls);
    return () => {
      document.documentElement.classList.remove(cls);
      document.body.classList.remove(cls);
    };
  }, [hidePublicChrome]);

  const routes = (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/tracking" element={<Tracking />} />
      <Route path="/track-package" element={<PackageTracking />} />
      <Route path="/admin/scan" element={<AdminPackageScan />} />
      <Route path="/pricing" element={<Pricing />} />
      <Route path="/services" element={<Services />} />
      <Route path="/cbm-calculator" element={<CbmCalculatorPage />} />
      <Route path="/about" element={<About />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/news" element={<News />} />
      <Route path="/sri-lanka-customs-baggage" element={<SriLankaBaggageCustoms />} />
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin" element={<Admin />} />
      <Route path="/register" element={<Register />} />
      <Route path="/login" element={<Login />} />
      <Route path="/auth/google/callback" element={<GoogleAuthCallback />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/logged-out" element={<LoggedOut />} />
      <Route path="/dashboard" element={<Navigate to="/profile" replace />} />
      <Route path="/review" element={<ReviewSubmit />} />
      <Route path="/review/thank-you" element={<ReviewSubmit />} />
      <Route path="/profile" element={<Profile />} />
      <Route path="/faqs" element={<LegalPage />} />
      <Route path="/terms" element={<LegalPage />} />
      <Route path="/privacy" element={<LegalPage />} />
      <Route path="/refund-policy" element={<LegalPage />} />
      <Route path="/careers" element={<LegalPage />} />
      <Route path="/help" element={<LegalPage />} />
      <Route path="/sitemap" element={<LegalPage />} />
    </Routes>
  );

  return (
    <div className={appClass}>
      {!hidePublicChrome && !isAdminRoute && <Navbar />}
      {isAdminRoute ? routes : hidePublicChrome ? routes : <main className="jet-main">{routes}</main>}
      {!hidePublicChrome && !isAdminRoute && <Footer />}
    </div>
  );
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <ThemeProvider>
        <ToastProvider>
          <AuthProvider>
            <AppContent />
          </AuthProvider>
        </ToastProvider>
      </ThemeProvider>
    </Router>
  );
}

export default App;
